import { FormContextValues } from '@dreryk/react-common';
import { FormController } from '@dreryk/react-components';

const EZWM_ENABLED_FIELD_NAME = 'ezwmEnabled';

export type EzwmEnabledFormBeanPart<VALUE extends boolean = boolean> = {
   [EZWM_ENABLED_FIELD_NAME]: VALUE;
};

type EzwmEnabledFieldProps = Pick<FormContextValues<EzwmEnabledFormBeanPart>, 'register'>;

export const EzwmEnabledField = (props: EzwmEnabledFieldProps): JSX.Element => {
   const controller = props.register(EZWM_ENABLED_FIELD_NAME);

   return <FormController controller={controller} />;
};
